import { useState, useRef, type ReactNode } from 'react';
import {
  SynthOIPutCallImpactConfig,
  SynthOIPCImpactDatum,
} from '../../../types';
import { BrushZoomConfig } from '../../../types/shared';
import { DEFAULT_BRUSH_ZOOM_CONFIG } from '../../../config';
import { SynthOIPutCallImpactContext } from './useSynthOIPutCallImpactCtx';

interface SynthOIPutCallImpactProviderProps {
  selectedSym: string;
  config: SynthOIPutCallImpactConfig;
  onConfigChange: (patch: Partial<SynthOIPutCallImpactConfig>) => void;
  children: ReactNode;
}

export const SynthOIPutCallImpactProvider = ({
  selectedSym,
  config,
  onConfigChange,
  children,
}: SynthOIPutCallImpactProviderProps) => {
  const [chartData, setChartData] = useState<SynthOIPCImpactDatum[]>([]);
  const [zoomConfig, setZoomConfig] = useState<BrushZoomConfig>(
    DEFAULT_BRUSH_ZOOM_CONFIG,
  );
  const chartRef = useRef<HTMLDivElement | null>(null);

  return (
    <SynthOIPutCallImpactContext.Provider
      value={{
        selectedSym,
        config,
        updateConfig: onConfigChange,
        chartData,
        setChartData,
        zoomConfig,
        setZoomConfig,
        chartRef,
      }}
    >
      {children}
    </SynthOIPutCallImpactContext.Provider>
  );
};
